import * as React from "react";
const SvgIcBatteryHalf = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M11 8V16H18V8H11ZM21 5V9H23V15H21V19H1V5H21Z" fill="currentColor" /></svg>;
export default SvgIcBatteryHalf;